export { default } from './PromotinalTag';
